<script>
export default {
  name: 'ReviewInfo',
  props: {
    title: {
      type: Object,
      required: false,
    },
    description: {
      type: Object,
      required: false,
    },
  },
};
</script>

<template>
  <v-card-text class="mx-2">
    <v-tooltip left>
      <template v-slot:activator="{ on: tooltip }">
        <h3 v-if="title" v-on="tooltip"> {{ title.text }}</h3>
        <h3 v-else v-on="tooltip"> {{ $t('review.reviewCard.noTitle') }}</h3>
      </template>
      <span>{{ $t('review.reviewCard.tooltip.title') }}</span>
    </v-tooltip>
    <br />
    <v-tooltip left>
      <template v-slot:activator="{ on: tooltip }">
        <p v-if="description" v-on="tooltip"> {{ description.text }}</p>
        <p v-else v-on="tooltip"> {{ $t('review.reviewCard.noDescription') }}</p>
      </template>
      <span>{{ $t('review.reviewCard.tooltip.description') }}</span>
    </v-tooltip>
  </v-card-text>
</template>



// WEBPACK FOOTER //
// src/components/review/ReviewInfo.vue